import React, {Component} from 'react';
import { Modal, ModalBody, ModalFooter, ModalHeader, UncontrolledTooltip} from "reactstrap";
import Select from "../../../local_node_modules/react-select"
import {validateComponent, validateField} from "../../../common/validation";
import Table from "../../../components/Table/Table";
import {deepCopyObject, showAxiosError} from "../../../helper/helper";
import Notify from "react-notification-alert";
import MaskedInput from "react-text-mask";
import emailMask from "text-mask-addons/dist/emailMask";
import {request} from "../../../helper/APIUtils";
import Alert from "react-s-alert";
import SweetAlert from "react-bootstrap-sweetalert";
import {VirtualHost} from "../../../constants";
import Datetime from "react-datetime";
import * as moment from "moment";

class CustomerBranchInfo extends Component {
	constructor(props) {
		super(props);

		this.notifyRef = React.createRef();

		this.state = {
			allAliasList: [],
			pkAliasList: [],
			gbAliasList: [],
			error: {},
			initCustAddData: '',
			deleteModal: false,
			branchDetailModal: false,
			branchList: [],
			page: 0,
			size: 10,
			alert: null
		};

		this.validateField = this.validateField.bind(this);
		this.validateClass = this.validateClass.bind(this);
		this.validateMessage = this.validateMessage.bind(this);
		this.validateComponent = this.validateComponent.bind(this);
		this.isChanged = this.isChanged.bind(this);
		this.toggle = this.toggle.bind(this);
		this.remoteSwitchBranchDetailModal = this.remoteSwitchBranchDetailModal.bind(this);
		this.arrangeData = this.arrangeData.bind(this);
		this.cancelCurrentBranch = this.cancelCurrentBranch.bind(this);
		this.handleEdit = this.handleEdit.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.showErrorMessage = this.showErrorMessage.bind(this);
	}

	componentDidMount() {
		let customerContractList = this.props.customerContractList;
		let allAliasList = [];
		let pkAliasList = [];
		let gbAliasList = [];
		customerContractList.map((cc) => {
			cc.customerContractServiceList.map((ccs) => {
				if (ccs.service.ublName === 'EFatura') {
					ccs.aliasList.map((alias) => {
						allAliasList.push(alias)
					})
				}
			})
		});

		allAliasList.map((alias) => {
			if (alias.userRolecode === 'PK') {
				pkAliasList.push(alias);
			} else {
				gbAliasList.push(alias);
			}
		});

		this.setState({
			pkAliasList,
			gbAliasList,
			allAliasList,
			branchList: this.props.branchList
		})
	}

	componentWillReceiveProps(nextProps) {
		if (this.props.mode !== 'edit') {
			let allAliasList = deepCopyObject(this.props.aliasList);
			let pkAliasList = [];
			let gbAliasList = [];

			allAliasList.map((alias) => {
				if (alias.userRolecode === 'PK') {
					pkAliasList.push(alias);
				} else {
					gbAliasList.push(alias);
				}
			});

			this.setState({
				allAliasList,
				pkAliasList,
				gbAliasList
			});
		}

		this.setState({branchList: this.props.branchList})
	}

	validateField(e) {
		let id = e.target.id;
		let rule = e.target.dataset.vdata;
		let boundary = e.target.dataset.vlength;
		let value = e.target.value;
        let error = this.state.error;
		let result;
		if (rule === "phone" && value.includes("_")) {
			result = validateField(rule, undefined, value);
		} else
        result = validateField(rule, boundary, value);
		error = Object.assign(error, {[id]: result});

		this.setState({error});
	}

	validateClass(id) {
		let error = this.state.error;
		return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
	}

	validateMessage(id) {
		let error = this.state.error;
		return (error[id] === undefined ? '' : (error[id].message));
	}

	validateComponent() {
		let customerBranchAddress = deepCopyObject(this.props.customerBranchAddress);
		let result = validateComponent(this);
		let error = {valid: true, message: ""};
		for (let value in customerBranchAddress) {
			if (value === "phone") {
				if(!!customerBranchAddress[value]) {
					let phoneError;
					if (customerBranchAddress[value].includes("_")) {
						phoneError = validateField("phone", undefined, customerBranchAddress[value]);
					} else
						phoneError = validateField("phone", "13,13", customerBranchAddress[value]);

					if (!phoneError.valid) {
						error.valid = false;
						error.message += phoneError.message ;
					}
				}
			}
		}
		result.error = Object.assign(result.error, {["tTelephone"]: error});
		result.valid = result.valid && error.valid;
		this.setState({error: result.error});
		return result;
	}

	handleEdit(data) {
		let index = this.state.branchList.indexOf(data);
		this.props.fillAddressForm(data, index);
		this.setState({
			initCustBranchData: data,
			selectedBranch: data
		});
		this.openBranchDetailModal();
	}

	handleDelete(data) {
		let self = this;
		if (this.props.branchList.length === 1) {
			Alert.error("En az 1 adet kayıtlı şubeniz bulunmalıdır!", {
				position: 'top-right',
				effect: 'stackslide',
				timeout: 5000
			});
		} else {
			let params = {
				url: "/customer/deleteCustomerBranch",
				method: "post",
				data: data.recordId
			};
			request(params)
				.then(function (response) {
					self.props.reload(true, "header");
					Alert.success("Şube başarıyla silindi.", {
						position: 'top-right',
						effect: 'stackslide',
						timeout: 5000
					});
				}).catch(function (error) {
				showAxiosError(error);
			});
		}
	}

	remoteSwitchBranchDetailModal() {
		if (this.state.branchDetailModal === false) {
			this.setState({
				branchDetailModal: true
			})
		} else {
			this.setState({
				branchDetailModal: false
			})
		}
	}

	isChanged(initState, input) {
		if (JSON.stringify(initState) === JSON.stringify(input)) {
			return false
		} else {
			return true
		}
	}

	openBranchDetailModal() {
		if (this.props.mode === 'edit') {
			let allAliasList = [];
			let gbAliasList = [];
			let pkAliasList = [];

			this.props.customerContractList.map(cc => {
				cc.customerContractServiceList.map(ccs => {
					if (ccs.service.recordId === 2) {
						ccs.aliasList.map(alias => {
							allAliasList.push(alias)
						})
					}
				})
			});

			allAliasList.map(all => {
				if (all.userRolecode === 'GB') {
					gbAliasList.push(all);
				} else {
					pkAliasList.push(all);
				}
			});
			this.setState({
				gbAliasList,
				pkAliasList,
				allAliasList,
				branchDetailModal: true
			})
		} else {
			this.setState({
				branchDetailModal: true
			})
		}
	}

	toggle() {
		this.setState({branchDetailModal: !this.state.modal});
	}

	arrangeData(page, size) {
		this.setState({
			page: page,
			size: size,
			loading: false
		});
	}

	cancelCurrentBranch() {
		this.props.clearCustomerBranchAddress();
		this.setState({branchDetailModal: false});
	}

	showErrorMessage() {
		let notificationAlertOptions = {
			place: 'tr',
			message: (
				<div>
					<div>
						Hatali alanlar var.
					</div>
				</div>
			),
			type: "danger",
			autoDismiss: 'none'
		};

		this.notifyRef.current.notificationAlert(notificationAlertOptions)
	}

	selectStyle(item) {
		let error = deepCopyObject(this.state.error);
		if (error[item] === undefined || error[item].valid) {
			return null;
		} else {
			return {backgroundColor: '#f8f8f8', borderColor: '#ffcfcf'}
		}
	}

	render() {
		let customerBranchAddress = this.props.customerBranchAddress;
		let branchName = VirtualHost.conf.resourcePrefix === "mikrokom" ? customerBranchAddress.branchName || "MERKEZ" : customerBranchAddress.branchName;

		const columns = [
			{
				Header: "Şube Adı",
				accessor: "branchName",
				sortable: false
			},
			{
				Header: "Şehir",
				accessor: 'city',
				sortable: false
			},
			{
				Header: "İlçe",
				accessor: 'citySubdivisionName',
				sortable: false
			},
			{
				Header: "Telefon",
				accessor: 'phone',
				sortable: false
			},
			{
				Header: "E-posta",
				accessor: 'email',
				sortable: false
			},
			{
				Header: "Web Sitesi",
				accessor: 'webSite',
				sortable: false
			},
			{
				Header: "",
				Cell: row => (
					<div>
						<button type="button" onClick={() => this.handleEdit(row)} rel="tooltip"
								className="btn btn-info btn-sm btn-icon "
								style={{margin: "0px", background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-edit"></i>
						</button>
						{row.recordId !== "" &&
						<button type="button" onClick={() => this.setState({
							alert: (
								<SweetAlert showCancel warning
											confirmBtnText="Evet"
											cancelBtnText="Hayır"
											confirmBtnBsStyle="danger"
											cancelBtnBsStyle="default"
											title="Emin misiniz?"
											onConfirm={() => {
												this.handleDelete(row)
											}}
											onCancel={() => this.setState({alert: null, notify: null})}>
									Şube bilgisi silinecek..! Onaylıyor musunuz ?
								</SweetAlert>
							)
						})} rel="tooltip"
								className="btn btn-danger btn-sm btn-icon "
								style={{margin: "0px", background: 'linear-gradient(rgb(120, 177, 215), rgb(120, 177, 215))'}}>
							<i className="fa fa-trash"></i>
						</button>
						}
					</div>
				)
			}
		];
		return (
			<div>
				{this.state.alert}
				<div className="col-sm-12 " style={{marginBottom: '20px'}}>
					<nav className="">
						<button type="button" data-toggle="tooltip" data-placement="bottom"
								style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)'}}
								rel="tooltip" className="TekBtn ekle btn-icon"
								disabled={this.props.fieldsDisabled}
								onClick={() => {
									this.openBranchDetailModal()
								}}>Şube Ekle
						</button>
					</nav>
				</div>

				<div className="card-body">
					<Table
						columns={columns}
						content={this.state.branchList}
						total={this.state.branchList.length}
						paginationEnabled={false}
					/>
				</div>

				<Modal isOpen={this.state.branchDetailModal} size='lg'>
					<ModalHeader toggle={this.cancelCurrentBranch}>Şube Detayları</ModalHeader>
					<ModalBody>
						<div>
							<Notify ref={this.notifyRef} className="modalAlert"/>
							<div className="col-sm-12 row form-row">
								<div className="col-sm-6 row">
									<div className="col-sm-6">
										<label className="col-form-label">Şube Adı *</label>
									</div>
									<div className="col-md-6">
										<div className={"form-group" + this.validateClass('tBranchName')}>
											<input className="form-control"
												   type="text"
												   name="branchName"
												   id="tBranchName"
												   data-vlength="1,45"
												   onBlur={this.validateField}
												   ref="tBranchName"
												   value={branchName}
												   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
											{this.validateMessage('tBranchName') !== "" &&
											<UncontrolledTooltip placement="right" target="tBranchName" delay={0}>
												{this.validateMessage("tBranchName")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								{VirtualHost.conf.resourcePrefix==="togb" &&
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Şube Unvanı: </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="branchFormattedName"
											   maxLength={255}
											   value={customerBranchAddress.branchFormattedName}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
								}

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Gönderici Etiketi *</label>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											{this.state.allAliasList.length !== 0 &&
											<Select
												clearable={false}
												className="select-control"
												name="gbAlias"
												id="tGbAlias"
												ref="tGbAlias"
												value={customerBranchAddress.gbAlias}
												placeholder="Seçiniz..."
												onChange={(e) => this.props.onAliasChange(e)}
												options={this.state.gbAliasList.map((alias) => ({
														value: alias.workScopecode,
														label: alias.workScopecode,
														name: 'gbAlias'
													})
												)}
											/>}
											{this.state.allAliasList.length === 0 &&
											<input placeholder='Kayıtlı etiket yok' disabled={true}
												   data-toggle="tooltip"
												   title="E-Fatura hizmetiniz bulunmamaktadır."/>}
										</div>
									</div>
								</div>


							</div>

							<div className="col-md-12 row form-row">
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Alıcı Etiketi *</label>
									</div>
									<div className="col-md-6">
										<div className="form-group">
											{this.state.allAliasList.length !== 0 &&
											<Select
												clearable={false}
												className="select-control"
												name="pkAlias"
												id="tPkAlias"
												ref="tPkAlias"
												value={customerBranchAddress.pkAlias}
												placeholder="Seçiniz..."
												onChange={(e) => this.props.onAliasChange(e)}
												options={this.state.pkAliasList.map(alias => ({
													value: alias.workScopecode,
													label: alias.workScopecode,
													name: 'pkAlias'
												}))}
											/>}
											{this.state.allAliasList.length === 0 &&
											<input placeholder='Kayıtlı etiket yok' disabled={true}
												   data-toggle="tooltip"
												   title="E-Fatura hizmetiniz bulunmamaktadır."/>}
										</div>
									</div>
								</div>
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Ülke *</label>
									</div>
									<div className="col-md-6">
										<div className={"form-group" + this.validateClass('tCountry')}>
											<input className="form-control"
												   type="text"
												   name="country"
												   id="tCountry"
												   data-vlength="1,45"
												   onBlur={this.validateField}
												   ref="tCountry"
												   value={customerBranchAddress.country}
												   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
											{this.validateMessage('tCountry') !== "" &&
											<UncontrolledTooltip placement="right" target="tCountry" delay={0}>
												{this.validateMessage("tCountry")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Şehir *</label>
									</div>
									<div className="col-sm-6">
										<div className={"form-group" + this.validateClass('tCity')}>
											<Select
												clearable={false}
												className="select-control"
												name="city"
												id="tCity"
												onBlur={() => this.validateField({
													target: {
														id: "tCity",
														dataset: {vdata: "required"},
														value: customerBranchAddress.city
													}
												})}
												inputProps={{'vdata': "city", 'vlength': "1,45"}}
												ref="tCity"
												value={customerBranchAddress.city}
												placeholder="Seçiniz..."
												style={this.selectStyle('tCity')}
												onChange={(e) => this.props.onCityChange(e)}
												options={this.props.cities.map(city => ({
													value: city.cityName,
													label: city.cityName
												}))}
											/>
											{this.validateMessage('tCity') !== "" &&
											<UncontrolledTooltip placement="right" target="tCity" delay={0}>
												{this.validateMessage("tCity")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">İlçe *</label>
									</div>
									<div className="col-sm-6">
										<div className={"form-group" + this.validateClass('tCitySubdivisionName')}>
											<Select
												clearable={false}
												className="select-control"
												name="citySubdivisionName"
												id="tCitySubdivisionName"
												onBlur={() => this.validateField({
													target: {
														id: "tCitySubdivisionName",
														dataset: {vdata: "required"},
														value: customerBranchAddress.citySubdivisionName
													}
												})}
												inputProps={{'vdata': "citySubdivisionName", 'vlength': "1,45"}}
												ref="tCitySubdivisionName"
												value={customerBranchAddress.citySubdivisionName}
												placeholder="Seçiniz..."
												style={this.selectStyle('tCitySubdivisionName')}
												onChange={(e) => this.props.onCitySubdivisionChange(e)}
												options={this.props.getSubdivisions(customerBranchAddress.city)}
											/>
											{this.validateMessage('tCitySubdivisionName') !== "" &&
											<UncontrolledTooltip placement="right" target="tCitySubdivisionName"
																 delay={0}>
												{this.validateMessage("tCitySubdivisionName")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>
							</div>

							<div className="col-md-12 row form-row">

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Web Sitesi </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="webSite"
											   value={customerBranchAddress.webSite}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">E-Posta *</label>
									</div>
									<div className="col-md-6">
										<div className={"form-group" + this.validateClass('tEmail')}>
											<MaskedInput className="form-control"
														 mask={emailMask}
														 placeholder="_________@______.___"
														 type="text"
														 name="email"
														 inputProps={{vdata:"email", vlength:'1,255'}}
														 id="tEmail"
														 ref="tEmail"
														 onBlur={() => this.validateField({
															 target: {
																 id: "tEmail",
																 dataset: {vdata: "email", vlength:'1,255'},
																 value: customerBranchAddress.email
															 }
														 })}
														 value={customerBranchAddress.email}
														 onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
											{this.validateMessage('tEmail') !== "" &&
											<UncontrolledTooltip placement="right" target="tEmail" delay={0}>
												{this.validateMessage("tEmail")}
											</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Telefon </label>
									</div>
									<div className="col-md-6">
										<div className={"form-group" + this.validateClass('tTelephone')}>
										<MaskedInput className="form-control"
													 mask={['+', '9', '0', /[1-9]/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/, /\d/]}
													 placeholder="+90__________"
													 type="text"
													 id="tTelephone"
													 inputProps={{vdata: "phone", vlength: '13,13'}}
													 guide={true}
													 name="phone"
													 onBlur={() => this.validateField({
														 target: {
															 id: "tTelephone",
															 dataset: {vdata: "phone", vlength: '13,13'},
															 value: customerBranchAddress.phone
														 }
													 })}
													 value={customerBranchAddress.phone}
													 onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
										{this.validateMessage('tTelephone') !== "" &&
										<UncontrolledTooltip placement="right" target="tTelephone" delay={0}>
											{this.validateMessage("tTelephone")}
										</UncontrolledTooltip>}
										</div>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Faks </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="fax"
											   value={customerBranchAddress.fax}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
							</div>

							<div className="col-md-12 row form-row">


								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Sokak </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="street"
											   value={customerBranchAddress.street}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Bina Adı </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="buildingName"
											   value={customerBranchAddress.buildingName}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

							</div>

							<div className="col-md-12 row form-row">

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Bina No </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="buildingNo"
											   value={customerBranchAddress.buildingNo}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6 ">
										<label className="col-form-label">Daire No </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="doorNo"
											   value={customerBranchAddress.doorNo}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Posta Kodu </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="postalCode"
											   value={customerBranchAddress.postalCode}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Müşteri No </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="customerNo"
											   maxLength={255}
											   value={customerBranchAddress.customerNo}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label" style={["togb", "eczacikart"].includes(VirtualHost.conf.resourcePrefix) ? {fontWeight: "bold"} : {fontWeight: "normal"}}>SGK Mükellef Kodu </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="sgkMukellefKodu"
											   value={customerBranchAddress.sgkMukellefKodu}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label" style={["togb", "eczacikart"].includes(VirtualHost.conf.resourcePrefix) ? {fontWeight: "bold"} : {fontWeight: "normal"}}>SGK Mükellef Adı </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   type="text"
											   name="sgkMukellefAdi"
											   value={customerBranchAddress.sgkMukellefAdi}
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>

								{VirtualHost.conf.resourcePrefix==="togb" &&<br/>}
								{VirtualHost.conf.resourcePrefix==="togb" &&
								<div className="col-md-12 row">
									<div className="col-md-12">
										<label className="col-form-label" style={{display:"flex",justifyContent:"center",fontWeight:"bold", fontSize:"15px"}}>Mesul Müdür Bilgileri </label>
									</div>
								</div>
								}
								{VirtualHost.conf.resourcePrefix==="togb" &&
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Ad Soyad </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   disabled={!customerBranchAddress.hasMesulMudur ? !customerBranchAddress.hasMesulMudur : false}
											   type="text"
											   name="mesulMudurAdSoyad"
											   maxLength={255}
											   value={customerBranchAddress.mesulMudurAdSoyad === null ? "" : customerBranchAddress.mesulMudurAdSoyad}
											   onChange={(e) => e && this.props.onChangeCustomerBranchAddress(e)}/>
									</div>
								</div>
								}
								{VirtualHost.conf.resourcePrefix==="togb" &&
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Müessese Ruhsatname Tarihi </label>
									</div>
									<div className="col-md-6 form-group">
										<Datetime locale="tr"
												  inputProps={{disabled: !customerBranchAddress.hasMesulMudur ? !customerBranchAddress.hasMesulMudur : false}}
												  className="datepicker"
												  input={true}
												  closeOnSelect={true}
												  value={moment(customerBranchAddress.mesulMudurRuhsatnameTarih, "YYYY-MM-DD", true).isValid() ? moment(customerBranchAddress.mesulMudurRuhsatnameTarih).format("DD-MM-YYYY") : customerBranchAddress.mesulMudurRuhsatnameTarih}
												  dateFormat="DD-MM-YYYY"
												  timeFormat={false}
												  isValidDate={function (current) {
													  return current.isBefore(Datetime.moment());
												  }}
												  onChange={(momentObj) => this.props.onChangeCustomerBranchAddress({
													  target: {
														  name: 'mesulMudurRuhsatnameTarih',
														  value: (!(typeof momentObj === "string") ? momentObj.format("YYYY-MM-DD") : momentObj)
													  }
												  })}/>
									</div>
								</div>
								}
								{VirtualHost.conf.resourcePrefix==="togb" &&
								<div className="col-md-6 row">
									<div className="col-md-6">
										<label className="col-form-label">Belge No </label>
									</div>
									<div className="col-md-6 form-group">
										<input className="form-control"
											   disabled={!customerBranchAddress.hasMesulMudur ? !customerBranchAddress.hasMesulMudur : false}
											   type="text"
											   name="mesulMudurBelgeNo"
											   maxLength={255}
											   value={customerBranchAddress.mesulMudurBelgeNo === null ? "" : customerBranchAddress.mesulMudurBelgeNo }
											   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>

									</div>
								</div>
								}
								{VirtualHost.conf.resourcePrefix === "togb" &&
									<div className="col-md-12 row">
										<div className="col-md-6">
											<label className="col-form-label">Optiysen Mesul Müdür Bilgilerini girmek istemiyorum </label>
										</div>
										<div className="col-md-6 form-group">
											<input type="checkbox"
												   name="hasMesulMudur"
												   checked={!customerBranchAddress.hasMesulMudur}
												   style={{float: "left", marginTop: "8px"}}
												   onChange={(e) => this.props.onChangeCustomerBranchAddress(e)}/>
										</div>
									</div>
								}
							</div>
						</div>
					</ModalBody>
					<ModalFooter>
						<nav className="col-sm-12 row">
							<div className="col-sm-2">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{background: 'rgb(158, 158, 158)', padding: '11px 45px 11px 20px'}}
										rel="tooltip" className="TekBtn vazgec"
										onClick={() => this.cancelCurrentBranch()}>İptal
								</button>
							</div>
							<div className="col-sm-8"></div>
							<div className="col-sm-2">
								<button type="button" data-toggle="tooltip" data-placement="bottom"
										style={{background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)', padding: '11px 45px 11px 20px'}}
										rel="tooltip" className="TekBtn kaydet"
										onClick={() => this.props.addBranchToCustomer()}>Onayla
								</button>
							</div>
						</nav>
					</ModalFooter>
				</Modal>

			</div>
		)
	}
}

export default CustomerBranchInfo;